import { render } from "./FrontofficeAide.vue?vue&type=template&id=bb034286&scoped=true&ts=true"
import script from "./FrontofficeAide.vue?vue&type=script&lang=ts"
export * from "./FrontofficeAide.vue?vue&type=script&lang=ts"

import "./FrontofficeAide.vue?vue&type=style&index=0&id=bb034286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb034286"]])

export default __exports__